import type { SgrDistributionResponseItem } from '../types/interfaces';

const sumByCurrency = (
  rows: SgrDistributionResponseItem[],
  code: string,
): number =>
  rows
    .filter((r) => r.currencyCode === code)
    .reduce((s, r) => s + (Number(r.amount) || 0), 0);

export interface SgrGroupDisplayTotal {
  /** Soft-rename: local currency bucket total (ARS|UYU); property name kept for callers. */
  ars: number;
  usd: number;
  isManual: boolean;
}

export function resolveSgrGroupDisplayTotal(
  rows: SgrDistributionResponseItem[],
  localCurrencyCode: string = 'ARS',
): SgrGroupDisplayTotal {
  const isManual = rows.some((r) => r.isManualBlockTotal === true);
  if (isManual) {
    const first = rows.find((r) => r.isManualBlockTotal) ?? rows[0];
    return {
      // soft-rename: `ars` property = local bucket (ARS or UYU)
      ars: Number(first.blockTotalArs ?? 0),
      usd: Number(first.blockTotalUsd ?? 0),
      isManual: true,
    };
  }
  return {
    ars: sumByCurrency(rows, localCurrencyCode),
    usd: sumByCurrency(rows, 'USD'),
    isManual: false,
  };
}

export function resolveSgrGrandDisplayTotals(
  distributions: SgrDistributionResponseItem[],
  localCurrencyCode: string = 'ARS',
): { ars: number; usd: number } {
  const bySgr = new Map<string, SgrDistributionResponseItem[]>();
  for (const row of distributions) {
    const key = row.sgrCode;
    if (!bySgr.has(key)) {
      bySgr.set(key, []);
    }
    bySgr.get(key)!.push(row);
  }

  let ars = 0;
  let usd = 0;
  for (const rows of bySgr.values()) {
    const totals = resolveSgrGroupDisplayTotal(rows, localCurrencyCode);
    ars += totals.ars;
    usd += totals.usd;
  }
  return { ars, usd };
}

export function hasManualMovilBlockTotal(
  distributions: SgrDistributionResponseItem[],
): boolean {
  return distributions.some(
    (r) => r.isMovil === true && r.isManualBlockTotal === true,
  );
}
